namespace GeniuzPOS.Product {
    export interface CsCategoryRow {
        Id?: number;
        CatCode?: string;
        CatName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullCatName?: string;
    }

    export namespace CsCategoryRow {
        export const idProperty = 'CatCode';
        export const nameProperty = 'FullCatName';
        export const localTextPrefix = 'Product.CsCategory';
        export const lookupKey = 'Product.CsCategory';

        export function getLookup(): Q.Lookup<CsCategoryRow> {
            return Q.getLookup<CsCategoryRow>('Product.CsCategory');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:หมวดสินค้า:Modify';

        export declare const enum Fields {
            Id = "Id",
            CatCode = "CatCode",
            CatName = "CatName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullCatName = "FullCatName"
        }
    }
}
